module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_16-432af8d5f835804ffd9c0cdba20fa09f.png";